import React from 'react';
export var UseOnClickOutside = function UseOnClickOutside(ref, handler) {
  React.useEffect(function () {
    var listener = function listener(event) {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler();
    };

    document.addEventListener('mousedown', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, handler]);
};